import React from "react";

interface ButtonProps {
  name: string; // The button text
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void; // Click event handler
  iconName?: string; // Optional icon name
  color?: string; // Optional color for the icon
  ariaLabel?: string; // Optional aria-label for accessibility
  className?: string; // Optional additional class names
  disabled?: boolean; // Optional disabled state
}


const Button: React.FC<ButtonProps> = ({
  name,
  onClick,
  iconName,
  color,
  ariaLabel,
  className,
  disabled = false, // Default value for disabled
}) => {
  return (
    <button onClick={onClick}  style={{cursor : 'pointer'}}  className={ className} disabled={disabled} aria-label={ariaLabel}>
      {/* {iconName && (
        <CustomIconButton
          iconName={iconName}
          color={color}
          ariaLabel={ariaLabel}
          onClick={onClick}
        />
      )} */}
      {name}
    </button>
  );
};

export default Button;
